<template lang="jade">
#app
  el-menu(:default-active="$route.path" style="min-width:1320px;" ,class="el-menu-demo",mode="horizontal",active-text-color="#173994",v-bind:class="{ toppost : $route.path == '/' }" router)
    el-menu-item(index="",style="padding-left: 9%")
      .logo
        .img
          img(src="static/logo2.png",style="height: 80px;width: 230px;")
    el-menu-item(index="/",style="margin-left:11%") 首页
    el-menu-item(index="/news") 新闻资讯
    el-submenu(index="/product?tab=0")
      template(slot="title")
        span 产品中心
      el-menu-item(v-for="(item, index) in productData",:index="`/product?tab=${index}`",:key="index") {{item.title }}
    el-menu-item(index="/building") 党建引领
    el-submenu(index="/anli?tab=0")
      template(slot="title")
        span 分子公司
      el-menu-item(v-for="(item, index) in companyData",:index="`/anli?tab=${index}`",:key="index") {{item.title }}
    el-menu-item(index="/culture") 企业文化
    el-menu-item(index="/case") 案例展示
    el-menu-item(index="/goto") 关于我们
  transition(enter-active-class="animated")
    router-view
  .bottombox
    ul(v-for="hrefs in hrefdata")
      li(v-for="item in hrefs")
        router-link(:to="item.href == 'javascript:;' ? '#' : item.href") {{ item.text }}
    ul
      li
        a(href="javascript:;") 联系我们
      li
        a(href="javascript:;") 
        i(class="el-icon-location-information", style="font-size:20px;color:#fff;")
        span(style="color: #fff;margin-left:6px;") 河南省郑州市经开区航海东路1689号
      li 
        a(href="javascript:;") 
        i(class="el-icon-message", style="font-size:20px;color:#fff;")
        span(style="color: #fff;margin-left:6px;") hnnyrl@hnnyrl.com
      li 
        a(href="javascript:;")
        i(class="el-icon-mobile-phone", style="font-size:20px;color:#fff;")
        span(style="color: #fff;margin-left:6px;") 0371-61620800
      li 
        img(src="../static/nyrl_code.jpg", style="width: 150px;height: 150px;margin-top: 20px;")
  .copyright 
    span 河南能源人力资源发展集团有限公司
    span(style="margin-left:20px;") 备案号:  
    a(href="https://beian.miit.gov.cn/#/Integrated/index", target="_blank" style="color: #fff;") 豫ICP备2022025010号-1
  side-bar(@gotoTop="gotoTop")
</template>

<script>
import axios from "./router/http";
import SideBar from "./components/SideBar.vue";
export default {
  name: "App",
  components: {
    SideBar: SideBar
  },
  data() {
    return {
      companyData: [],
      productData: [],
      appurl: "",
      transitionName: "",
      activeIndex: "/",
      hrefdata: [
        [
          {
            href: "javascript:;",
            text: "走进能源人力"
          },
          {
            href: "/goto?tab=1",
            text: "公司简介"
          }
        ],
        [
          {
            href: "javascript:;",
            text: "新闻资讯"
          },
          {
            href: "/news",
            text: "公司新闻"
          }
        ],
        [
          {
            href: "javascript:;",
            text: "党建引领"
          },
          {
            href: "/building",
            text: "党建引领"
          }
        ],
        [
          {
            href: "javascript:;",
            text: "企业文化"
          },
          {
            href: "/culture",
            text: "企业文化"
          }
        ],
        [
          {
            href: "javascript:;",
            text: "案例展示"
          },
          {
            href: "/case",
            text: "案例展示"
          }
        ]
      ]
    };
  },

  created: function() {
    this.getCompanyList();
    setTimeout(this.getProductList());
  },
  methods: {
    gotoTop() {
      $("html,body").animate({ scrollTop: 0 }, 50);
    },
    getProductList() {
      axios
        .get(`/front/product/list`, {
          params: {
            page: 1,
            pageSize: 20,
            status: 1
          }
        })
        .then(response => {
          this.productData = response.data.data.rows;
          let productArr = [
            {
              href: "javascript:;",
              text: "产品中心"
            }
          ];
          let processData = this.productData.map((item, index) => {
            return {
              href: "/product?tab=" + index,
              text: item.title
            };
          });
          this.hrefdata.push([...productArr, ...processData]);
        });
    },
    getCompanyList() {
      axios
        .get(`/front/company/list`, {
          params: {
            page: 1,
            pageSize: 20,
            status: 1
          }
        })
        .then(response => {
          this.companyData = response.data.data.rows;
          let companyArr = [
            {
              href: "javascript:;",
              text: "分子公司"
            }
          ];
          let processData = this.companyData.map((item, index) => {
            return {
              href: "/anli?tab=" + index,
              text: item.title
            };
          });
          this.hrefdata.push([...companyArr, ...processData]);
        });
    }
  }
};
</script>

<style lang="less">
@import "./../static/css/public.min.css";

.el-submenu__title {
  font-size: 16px !important;
  line-height: 71px !important;
}

.el-menu--horizontal .el-menu-item {
  font-size: 14px;
}

.el-menu--popup{
  width: 700px !important;
}
.el-menu--horizontal>.el-submenu .el-submenu__title {
  color: #333 !important;
}

.el-menu--horizontal .el-menu .el-menu-item{
  width: 350px !important;
  float: left !important;
}

.el-submenu__icon-arrow {
  margin-top: 2px !important;
}

body {
  padding: 0;
  margin: 0;
}

html,
body,
div,
span,
iframe,
blockquote,
pre,
a,
address,
big,
cite,
code,
del,
em,
font,
img,
ins,
small,
strong,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend {
  margin: 0;
  padding: 0;
}

html,
body,
div,
p,
a,
h1,
h2,
h3,
h4,
h5,
li,
ol,
ul,
strong,
span {
  font-family: "微软雅黑";
}

li,
ol,
ul {
  list-style: none outside;
}

:focus {
  outline: 0;
}

a img {
  border: 0;
}

a {
  text-decoration: none;
}

img {
  vertical-align: middle;
}

table {
  empty-cells: show;
}

ins {
  text-decoration: none;
}

del {
  text-decoration: line-through;
}

em {
  font-style: normal;
}

button::-moz-focus-inner,
input[type="reset"]::-moz-focus-inner,
input[type="button"]::-moz-focus-inner,
input[type="submit"]::-moz-focus-inner,
input[type="file"] > input[type="button"]::-moz-focus-inner {
  border: 0;
  padding: 0;
}

a {
  transition: color 0.4s ease-in-out;
  -moz-transition: color 0.4s ease-in-out;
  -webkit-transition: color 0.4s ease-in-out;
  -o-transition: color 0.4s ease-in-out;
}

* {
  font-family: "Helvetica";
  box-sizing: border-box;
}

.pagetop {
  width: 100%;
  height: 300px;
  background-size: cover;
  background-position: center center;
}

.pagetop h1 {
  margin: 0;
  line-height: 300px;
  text-align: center;
  color: #fff;
  font-size: 45px;
  font-weight: 400;
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.pos_r {
  position: relative;
}

.pos_a {
  position: absolute;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.overh {
  overflow: hidden;
}

.line-group {
  > h3 {
    font-size: 34px;
    font-weight: normal;
    color: #333333;
    text-align: center;
    margin: 20px 0;
  }
}

.top-cover {
  padding-top: 9%;
  text-align: center;
  position: absolute;
  top: 0;
  width: 100%;
  min-width: 1320px;

  h1 {
    font-size: 42px;
    color: #fff;
  }

  span {
    width: 165px;
    height: 1px;
    background-color: #fff;
    display: block;
    margin: 16px auto 0;
  }

  p {
    font-size: 22px;
    color: #fff;
    margin-top: 32px;
    display: block;
  }
}

.el-menu-item {
  font-size: 16px !important;
}

.copyright {
  background: #D4B56B;
  color: #fff;
  text-align: center;
  padding: 10px 0 10px 0;
  width: 100%;
}
</style>

<style scoped>
.toppost {
  position: absolute;
  top: 0;
  z-index: 999;
  width: 100% !important;
}

.el-menu {
  border-bottom: none;
  width: 100%;
}

.el-menu-item a {
  width: 100%;
  height: 100%;
  display: block;
  text-decoration: none;
}

.bottombox {
  width: 100%;
  overflow: hidden;
  background-color: #173994;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: center;
  padding: 1.4% 3%;
}

.bottombox ul {
  float: left;
  list-style: none;
  padding: 0 1.5%;
  min-height: 216px;
}

.bottombox ul:nth-of-type(1) {
}

.bottombox ul li:first-child {
  margin-bottom: 18px;
}

.bottombox ul li:first-child a:after {
  content: "";
  display: block;
  width: 32px;
  height: 1px;
  margin-top: 6px;
  background: #d9d9d9;
}

.bottombox ul:nth-child(6) {
  border-right: 0;
}

.bottombox ul:nth-child(6) li:first-child {
  margin-bottom: 18px;
}

.bottombox ul li {
  line-height: 36px;
  font-size: 14px;
}

.bottombox ul li:first-child a {
  font-size: 16px;
  font-weight: bold;
  color: #fff;
}

.bottombox ul li a {
  text-decoration: none;
  color: #f7f7f7;
  font-weight: 300;
}

.bottombox ul li a:hover {
  color: #fff;
}

.bottomercode {
  width: 170px;
  position: absolute;
  right: 10%;
  margin-top: 10px;
  padding: 15px;
  background: #fff;
  border: 2px solid #173994;
}

.topdoli {
  float: right;
  line-height: 60px;
  margin-right: 6%;
}

.topdoli a {
  text-decoration: none;
  color: #808080;
  font-weight: 300;
}

.logo {
  display: flex;
  flex-direction: row;
}

.text {
  margin-left: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.zh-title {
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
  line-height: 0;
  color: #333;
}

.cn-title {
  color: #666;
  font-size: 12px;
  line-height: 50px;
  letter-spacing: 2px;
}

.logo-border {
  display: inline-block;
  height: 65px;
  margin-left: 12px;
  margin-right: 16px;
  border: 1px solid #173994;
}

.el-menu--horizontal > .el-menu-item {
  height: 75px !important;
  line-height: 75px !important;
  overflow: hidden;
  color: #333;
}

</style>


// WEBPACK FOOTER //
// src/App.vue